import {ShapefileAttributeType} from '../api';

/**
 * Čitelný český název datového typu atributu importované vrstvy (shapefile).
 */
export const getShapefileAttributeTypeReadable = (typ: string | ShapefileAttributeType): string => {
    switch (typ) {
        case ShapefileAttributeType.INTEGER:
            return 'Číslo';
        case ShapefileAttributeType.INTEGER64:
            return 'Číslo (64bit)';
        case ShapefileAttributeType.STRING:
            return 'Jednořádkový text';
        case ShapefileAttributeType.REAL:
            return 'Desetinné číslo';
        case ShapefileAttributeType.BOOLEAN:
            return 'Ano/Ne';
        case ShapefileAttributeType.DATETIME:
            return 'Datum a čas';
        case ShapefileAttributeType.CISELNIK:
            return 'Číselník';
        case ShapefileAttributeType.ACCESSIBILITY:
            return 'Přístupnost pro vozíčkáře';
        default:
            return `_${typ}`;
    }
};

/**
 * Položky výběru datového typu pro import atributu shapefile vrstvy s čitelnými českými názvy.
 */
export const getShapefileAttributeTypeItems = (): {id: ShapefileAttributeType; name: string}[] =>
    Object.keys(ShapefileAttributeType).map((t: ShapefileAttributeType) => ({id: t, name: getShapefileAttributeTypeReadable(t)}));
